import { GameStateEnums } from '../../../../shared/GameEnums.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { ActionState, TurnState } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameTurnSoundController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GameStateUpdated:
                this.playTurnSound();
                break;
            default:
                break;
        }
        this.oldState = this.uiGameManager.gameController.currentState.turnState;
    }
    playTurnSound() {
        if (this.uiGameManager.gameController.currentState.actionState != ActionState.None) return;
        if (this.uiGameManager.gameController.currentState.turnState == this.oldState) return;
        if (!this.uiGameManager.gameController.isMyTurn) return;
        if (this.statesToPlayTurnSound()) AudioManager.play(AudioType.YourTurn);
    }
    statesToPlayTurnSound() {
        if (this.uiGameManager.gameController.isReplay) return false;
        if (this.uiGameManager.gameController.currentState.turnState == TurnState.Dice) return true;
        return false;
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.oldState = TurnState.InitialPlacement;
    }
}
